import { Blog, ContentPageTheme } from "@/services/bedrock";
import { EditableBlog } from "./BlogModal/BlogEditor";

export type BlogPreviewAuthor = {
  fullName?: string;
  photoUrl?: string;
};

export const tagsFromDraft = (tags: string[]): string[] => tags.map(tag => tag.trim()).filter(Boolean);

export const themeForPreview = (
  draft: EditableBlog,
  themes: ContentPageTheme[],
  fallback?: ContentPageTheme | null
): ContentPageTheme | undefined => {
  if (draft.themeId == null) return fallback ?? undefined;
  return themes.find(theme => theme.id === draft.themeId) ?? fallback ?? undefined;
};

export const toBlogPreviewPayload = (
  blog: Blog,
  draft: EditableBlog,
  theme?: ContentPageTheme | null,
  author?: BlogPreviewAuthor
) => {
  const video =
    blog.contentPage?.originalMedia?.find(media => media.category === "VIDEO") ?? blog.contentPage?.originalMedia?.[0];

  return {
    guid: blog.guid,
    slug: blog.slug,
    title: draft.title,
    subtitle: draft.subtitle,
    metaDescription: draft.metaDescription,
    excerpt: draft.excerpt,
    body: draft.body,
    tags: tagsFromDraft(draft.tags),
    readingTimeMinutes: blog.readingTimeMinutes ?? undefined,
    publishedAt: blog.publishedAt ?? undefined,
    url: blog.url,
    trackedUrl: blog.trackedUrl,
    thumbnailUrl: blog.thumbnailUrl,
    disclaimer: blog.disclaimer ?? undefined,
    callToAction: blog.callToAction
      ? { label: blog.callToAction.label, link: blog.callToAction.customLink || "" }
      : null,
    contentPageTheme: theme ?? blog.effectiveContentPageTheme ?? blog.contentPageTheme,
    author: {
      fullName: author?.fullName || blog.author?.fullName || "The SocialCoach Team",
      photoUrl: author?.photoUrl || blog.author?.photoUrl,
    },
    video: video
      ? {
          id: video.id,
          uri: video.uri,
          width: video.width,
          height: video.height,
          type: video.type,
          category: video.category,
          extension: video.extension,
        }
      : null,
    sourceVideoPageSlug: blog.contentPage?.slug ?? null,
  };
};
